export default {
  goBackProfile: 'Профиль',
  mainTitle: 'Выберите способ подписания',
  onlineSigning: 'Электронная подпись',
  offlineSigning: 'Приехать в офис',
  digital: {
    title: 'Электронная подпись договора',
    text: 'Чтобы подписать договор при помощи УКЭП, \nследуйте инструкции по ',
    link: ' ссылке'
  },
  offline: {
    title: 'Выберите дату и время',
    text: 'г. Казань, ул. Альберта Камалеева, 28/9',
    approximateDay: 'Примерный день',
    approximateTime: 'Примерное время'
  },
  months: {
    january: 'января',
    february: 'февраля',
    march: 'марта',
    april: 'апреля',
    may: 'мая',
    june: 'июня',
    july: 'июля',
    august: 'августа',
    september: 'сентября',
    october: 'октября',
    november: 'ноября',
    december: 'декабря'
  },
  weekdays: {
    monday: 'Пн',
    tuesday: 'Вт',
    wednesday: 'Ср',
    thursday: 'Чт',
    friday: 'Пт'
  },
  firstHalfOfDay: 'С 9 до 14',
  secondHalfOfDay: 'С 14 до 19',
  done: 'Готово'
}
